import React, { useEffect, useState } from "react";
import * as apis from "../apis";
import PrivacyPolicy from "../components/PrivacyPolicy/PrivacyPolicy";

export default function PrivacyPolicyContainer() {
  const [data, setData] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await apis.getTerms();
        setData(res?.data?.privacyTerm);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);

  return <PrivacyPolicy data={data} />;
}
